document.addEventListener("DOMContentLoaded", function() {
    // Body Click Events
    document.body.addEventListener('click', function (event) {
        if (event.target.classList.contains('sub-qty') || event.target.classList.contains('add-qty')) {
            trg_updateQuantity(event.target);
        }
    });

    // Cart updated events
    document.addEventListener('product-ajax:added', function (evt) {
        trg_initAutoCloseCartDrawer();
    });

    // Clear auto-close interval when user manually closes the cart drawer
    document.querySelector("#CartDrawer .drawer__close-btn").addEventListener('click', function() {
        clearInterval(trg_autoCloseIntervalId);
    });

    // Cart drawer mouse over events
    document.querySelector("#CartDrawer").addEventListener("mouseover", function() {
        this.classList.add("trg_mouse-over-cart");
    });
    document.querySelector("#CartDrawer").addEventListener("mouseout", function() {
        this.classList.remove("trg_mouse-over-cart");
    });

    // After cart drawer is hidden events
    document.querySelector("#CartDrawer").addEventListener("drawer:handleAfterHide", function() {
        // Remove modal-show from the body as soon as the cart drawer finishes hiding.
        // This fires synchronously before the theme sets hidden=true on the drawer,
        // closing the gap where modal-show's padding-right would briefly flash back in.
        document.body.classList.remove("modal-show");
    });

    // Chat window click event
    document.addEventListener("click", function(event) {
        const target = event.target;

        if ((target.nodeName === 'A' || target.nodeName === 'BUTTON') &&
            target.getAttribute('href') === '#showChatWindow') {
            trg_showChatWindowOnClick(event);
        }
    });

    trg_PreventProductGridSearchOnEnterPress();
});


let trg_autoCloseIntervalId = null;

function trg_autoCloseCartDrawer() {
    let cartDrawer = document.getElementById("CartDrawer");

    // If cart is open
    if (cartDrawer.hasAttribute('open')) {
        trg_autoCloseIntervalId = setInterval(function() {

            // If the close button is found, click it after 2 seconds if the mouse is not over the cart drawer
            if (!cartDrawer.classList.contains('trg_mouse-over-cart')) {
                if (document.querySelector("#CartDrawer .drawer__inner").contains(document.querySelector("#CartDrawer .drawer__close-btn"))) {
                    // Clear the activeElement reference on the drawer before closing.
                    // The theme's handleAfterHide calls removeTrapFocus(activeElement) which
                    // calls .focus() on whatever element opened the drawer (e.g. Add to Cart btn).
                    // If that element is off-screen, the browser scrolls to it — clearing
                    // activeElement prevents that focus call from happening at all.
                    cartDrawer.activeElement = null;

                    cartDrawer.addEventListener('drawer:handleAfterHide', function() {
                        document.body.classList.remove("trg_allow-scroll-with-cart-drawer");
                    }, { once: true });

                    document.querySelector("#CartDrawer .drawer__inner .drawer__close-btn").click();
                    clearInterval(trg_autoCloseIntervalId);
                }
            }
        }, 2000);
    
        // Clear interval when cart drawer is removed from DOM
        cartDrawer.addEventListener('DOMNodeRemoved', function() {
            clearInterval(trg_autoCloseIntervalId);
        });
    }
}

function trg_initAutoCloseCartDrawer() {
    document.body.classList.add("trg_allow-scroll-with-cart-drawer");
    let cartDrawer = document.getElementById("CartDrawer");

    window.setTimeout(function() {
        trg_autoCloseCartDrawer();
    }, 500);
}

//-- Custom Quantity Input --//
function trg_updateQuantity(clickedBtn) {
    const quantityInput = clickedBtn.closest('.trg_custom-qty-input').querySelector('.custom-qty-input');

    if (clickedBtn.classList.contains('sub-qty')) {
        quantityInput.value = parseInt(quantityInput.value) - 1;
    } else if (clickedBtn.classList.contains('add-qty')) {
        quantityInput.value = parseInt(quantityInput.value) + 1;
    }
}


//-- Custom Quantity Input --//
function trg_updateQuantity(clickedBtn) {
    const quantityInput = clickedBtn.closest('.trg_custom-qty-input').querySelector('.custom-qty-input');

    if (clickedBtn.classList.contains('sub-qty')) {
        if (parseInt(quantityInput.value) <= parseInt(quantityInput.min)) {
            return;
        }
        quantityInput.value = parseInt(quantityInput.value) - 1;
    } else if (clickedBtn.classList.contains('add-qty')) {
        quantityInput.value = parseInt(quantityInput.value) + 1;
    }
}


document.addEventListener('open', (event) => {
    // Only react to events from <shopify-account>, not other components
    if (event.target.tagName.toLowerCase() === 'shopify-account') {
        console.log('Account sheet opened from', event.target);
    }
});


function trg_PreventProductGridSearchOnEnterPress() {
    const selector = "#ProductGridContainer #gf-controls-container form";

    function attachListener(form) {
        form.addEventListener("submit", function(event) {
            event.preventDefault();
        });
    }

    const existing = document.querySelector(selector);
    if (existing) {
        attachListener(existing);
        return;
    }

    if (!document.querySelector("#ProductGridContainer")) {
        return;
    }

    const observer = new MutationObserver(function() {
        const form = document.querySelector(selector);
        if (form) {
            attachListener(form);
            observer.disconnect();
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });
}


function trg_showChatWindowOnClick(event) {
    event.preventDefault();
    history.pushState({}, document.title, window.location.pathname + window.location.search);
    GorgiasChat.open();
    return false;
}
